import { successColor, hexToRgb } from 'assets/jss/material-dashboard-pro-react';

const forgotPageStyle = () => ({
	footer: {
		justifyContent: 'center !important',
		display: 'block',
		textAlign: 'center',
		marginBottom: 178,
		marginTop: 7,
	},
	cardBody: {
		marginTop: 8,
	},
	buttonContainer: {
		textAlign: 'center',
		marginTop: 49,
	},
	successBox: {
		padding: '16px 24px',
		borderRadius: 8,
		border: `solid 1px ${successColor[0]}`,
		backgroundColor: `rgba(${hexToRgb(successColor[0])}, 0.06)`,
		marginBottom: 41,
		marginTop: 24,
	},
	email: {
		fontWeight: 'bold',
	},
	iconContainer: {
		textAlign: 'center',
	},
	loginUnsuccessful: {
		marginBottom: 18,
	},
});

export default forgotPageStyle;
